import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import './ToolPage.css'
import { createWebhookBin } from './utils/apiClient'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const WebhookTesterCreate = () => {
  useDocumentMeta({
    title: 'Webhook Tester / Request Bin | jarder.dev',
    description:
      'Gere uma URL única e veja em tempo real qualquer requisição HTTP ' +
      'que chegar nela. Grátis, útil pra testar webhooks e integrações.',
  })

  const history = useHistory()
  const [status, setStatus] = useState('idle')
  const [error, setError] = useState('')

  const create = async () => {
    setStatus('loading')
    setError('')
    try {
      const { id } = await createWebhookBin()
      trackEvent('tool_generate', { tool: 'webhook_tester' })
      history.push(`/ferramentas/webhook-tester/${id}`)
    } catch {
      setError(
        'Não foi possível criar o endpoint agora. O servidor da API pode estar fora do ar. Tente novamente.',
      )
      setStatus('idle')
    }
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Webhook Tester / Request Bin</h1>
      <p className="tool-disclaimer">
        Gera uma URL única: qualquer requisição HTTP (GET, POST, webhook de
        qualquer serviço) que chegar nela aparece ao vivo na tela, sem
        precisar recarregar a página.
      </p>

      <button
        type="button"
        className="tool-button"
        onClick={create}
        disabled={status === 'loading'}
      >
        {status === 'loading' ? 'Criando...' : 'Criar endpoint'}
      </button>

      {error && <p className="tool-error">{error}</p>}

      <div className="tool-info-section">
        <h2>Como funciona</h2>
        <p>
          Ao criar, você recebe uma URL única. Mande qualquer requisição
          HTTP pra ela (webhook do Stripe, GitHub, um <code>curl</code>, o
          que for) e o conteúdo aparece na hora nessa mesma tela.
        </p>
        <p>
          Os endpoints são temporários: depois de um tempo sem receber
          nenhuma requisição, eles expiram e os dados são apagados.
        </p>
        <p>
          Não mande segredos de produção de verdade (chaves de API, senhas,
          dados de cliente) pra cá: essa URL não é privada de um jeito
          forte, ela só serve como identificador. Além disso, ela funciona
          tanto pra enviar quanto pra ver o que foi capturado, então quem
          tiver essa URL consegue ler o conteúdo, não só entregar dados
          nela.
        </p>
      </div>
    </div>
  )
}

export default WebhookTesterCreate
